import {
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { useUserId } from "../../../query/hooks/helpers";
import { useQueryMemberProfile } from "../../../query/users/queries";
import { DataView } from "../../../shared/components/DataView";
import { AlertEnableTaxWithholdings } from "../../Taxes/components/AlertEnableTaxWithholdings";
import { AlertEstimatedTaxWithholdings } from "../../Taxes/components/AlertEstimatedTaxWithholdings";
import { CardTaxWithholdingStatus } from "../../Taxes/components/CardTaxWithholdingStatus";
import { PATH_TAXES_EDIT_TAX_PROFILE } from "../../Taxes/paths";
import {
  formatFilingCode,
  formatIncomeEstimate,
  formatStateOfResidence
} from "../../Taxes/utils";
import { BannerBankingVerification } from "../../Wallet/components/BannerBankingVerification";
import { PATH_SETTINGS_TAX_PROFILE } from "../paths";

export const RouteTaxProfile = () => {
  const history = useHistory();
  const userId = useUserId();
  const queryMember = useQueryMemberProfile(userId);

  return (
    <WSPage>
      <WSPageToolbar title="Tax profile" />

      <WSGrid gutter="2XL">
        <WSGrid.Item span={{ s: "12", m: "8" }}>
          <WSList gap="2XL">
            <BannerBankingVerification />

            <AlertEnableTaxWithholdings />

            <AlertEstimatedTaxWithholdings />

            <DataView
              title="Filing basic"
              onEdit={() => {
                history.push(PATH_TAXES_EDIT_TAX_PROFILE, {
                  backPath: PATH_SETTINGS_TAX_PROFILE,
                  nextPath: PATH_SETTINGS_TAX_PROFILE
                });
              }}
              data={[
                {
                  label: "Tax filing status",
                  value: formatFilingCode(
                    queryMember.data?.profile.taxInfo?.filingCode
                  )
                },
                {
                  label: "Estimated annual income",
                  value: formatIncomeEstimate(
                    queryMember.data?.profile.taxInfo?.incomeEstimateForYear
                  )
                },
                {
                  label: "Tax filing state",
                  value: formatStateOfResidence(
                    queryMember.data?.profile.taxInfo?.stateOfResidence
                  )
                }
              ]}
            />
          </WSList>
        </WSGrid.Item>

        <WSGrid.Item span={{ s: "12", m: "4" }}>
          <WSList gap="2XL">
            <CardTaxWithholdingStatus isSettings />
          </WSList>
        </WSGrid.Item>
      </WSGrid>
    </WSPage>
  );
};
